import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { motion } from 'framer-motion';
import SectionHeader from '@/components/shared/SectionHeader';
import { getIcon } from '@/lib/icons';
import { ArrowRight } from 'lucide-react';

const ServicesSection = ({ services = [] }) => {
    return (
        <section
            className="section-pad bg-[hsl(var(--secondary))]/50 relative overflow-hidden"
            data-testid="home-services-section"
        >
            <div className="absolute inset-0 grain-bg opacity-60 pointer-events-none" />
            <div className="container-page relative">
                <div className="flex items-end justify-between gap-6 flex-wrap">
                    <SectionHeader
                        eyebrow="What We Do"
                        title="Six ways VVVSI serves communities."
                        description="From employment and career guidance to health, education, environment and disaster relief."
                    />
                    <Link
                        to="/services"
                        className="text-sm font-semibold text-[hsl(var(--primary))] flex items-center gap-1 hover:underline"
                        data-testid="services-view-all"
                    >
                        View all services <ArrowRight className="h-4 w-4" />
                    </Link>
                </div>
                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="services-grid">
                    {services.map((s, i) => {
                        const Icon = getIcon(s.icon);
                        return (
                            <motion.div
                                key={s.id || s.title}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: i * 0.05 }}
                                viewport={{ once: true, margin: '-60px' }}
                            >
                                <Card className="h-full bg-card border-border shadow-[0_10px_30px_rgba(15,23,42,0.05)] card-lift group">
                                    <CardContent className="p-6 flex flex-col h-full">
                                        <div className="h-12 w-12 rounded-xl bg-[hsl(var(--primary))]/8 text-[hsl(var(--primary))] flex items-center justify-center mb-4 group-hover:bg-[hsl(var(--accent))]/15 group-hover:text-[hsl(var(--accent))] transition-colors">
                                            <Icon className="h-6 w-6" />
                                        </div>
                                        <div className="font-display font-semibold text-lg mb-2">
                                            {s.title}
                                        </div>
                                        <p className="text-sm text-muted-foreground leading-relaxed flex-1">
                                            {s.short_description}
                                        </p>
                                        <Link
                                            to="/services"
                                            className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[hsl(var(--primary))] hover:text-[hsl(var(--accent))]"
                                        >
                                            Learn more <ArrowRight className="h-3.5 w-3.5" />
                                        </Link>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
